import React from 'react'
import PropTypes from 'prop-types'
import CircularProgress from '@material-ui/core/CircularProgress'
import Skeleton from '@material-ui/lab/Skeleton'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles(
  {
    loading: {
      minHeight: '60vh',
      alignItems: 'center',
      textAlign: 'center',
      justifyContent: 'center',
      display: 'flex'
    }
  },
  { name: 'bund-' }
)

export const Loading = (props) => {
  const {
    minHeight,
    size,
    type,
    width,
    height,
    variant,
    className,
    animation,
    style,
    radius,
    padding,
    margin
  } = props
  const classes = useStyles()

  return type === 'skeleton' ? (
    <Skeleton
      className={className}
      width={width}
      height={height}
      variant={variant}
      animation={animation}
      style={
        style
          ? style
          : {
              borderRadius:
                variant === 'text' || variant === 'rect'
                  ? radius + 'px'
                  : '50%',
              padding: padding,
              margin: margin
            }
      }
    />
  ) : (
    <div
      className={classes.loading}
      style={{
        minHeight: minHeight
      }}>
      <CircularProgress
        style={{ width: size, height: size }}
        className="text-color"
      />
    </div>
  )
}

Loading.propTypes = {
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  minHeight: PropTypes.string,
  size: PropTypes.string,
  type: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  variant: PropTypes.oneOf(['text', 'rect', 'circle']),
  className: PropTypes.oneOf(['skeleton-light', 'skeleton']),
  animation: PropTypes.oneOf(['pulse', 'wave']),
  radius: PropTypes.number,
  padding: PropTypes.string,
  margin: PropTypes.string
}

Loading.defaultProps = {
  className: 'skeleton',
  variant: 'text',
  animation: 'pulse',
  radius: 6,
  padding: '0px',
  margin: '0px'
}

Loading.displayName = 'l'

export default Loading
